import {
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  findCustomId: (param) => {   // 商户端对账单列表
    return GET('/merchant/reconciliationTable/dz/findReconciliationInCustomId', param)
  },
  customIdExport: (param, rsType) => { // 商户端对账单列表-导出
    return GETPDF("/merchant/reconciliationTable/dz/findReconciliationInCustomIdExport", param, rsType);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/statement-account.js